import phraseList from '@/data/mypage/what-we-do.json';
import React, { FC, HTMLAttributes } from 'react';

const getRandomIndex = () => Math.floor(Math.random() * phraseList.length);

const WhatWeDoPhrase: FC<HTMLAttributes<HTMLParagraphElement>> = React.memo(
  (props) => {
    const phrase = phraseList[getRandomIndex()];
    return <p {...props}>{phrase.content}</p>;
  },
);

export default WhatWeDoPhrase;
